import { render, staticRenderFns } from "./BtnInserirCronogramaFisico.vue?vue&type=template&id=270e4f00"
import script from "./BtnInserirCronogramaFisico.vue?vue&type=script&lang=js"
export * from "./BtnInserirCronogramaFisico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports